import { api } from '@/lib/api';
import type {
  VoiceResponse, VoiceQuery, VoiceDropdownItem, UpdateVoiceRequest
} from '@troia-v3/types';

interface VoiceListResponse {
  items: VoiceResponse[];
  total: number;
  page: number;
  totalPages: number;
}

export const voicesApi = {
  async getAll(query?: VoiceQuery): Promise<VoiceListResponse> {
    const response = await api.get('/voices', { params: query });
    return response.data.data;
  },

  async getById(id: string): Promise<VoiceResponse> {
    const response = await api.get(`/voices/${id}`);
    return response.data.data;
  },

  async create(formData: FormData): Promise<VoiceResponse> {
    const response = await api.post('/voices', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  },

  async update(id: string, data: UpdateVoiceRequest): Promise<VoiceResponse> {
    const response = await api.patch(`/voices/${id}`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/voices/${id}`);
  },

  async getDropdown(): Promise<VoiceDropdownItem[]> {
    const response = await api.get('/voices/dropdown');
    return response.data.data;
  },
};
